const comments = [
  {
    name: '匿名用户A7K3',
    time: '2小时前',
    content: '作为暗网入门新手，这篇指南真的太详细了！从Tor浏览器下载到安全配置，每一步都有图文说明，帮我少走了很多弯路。特别是VPN搭配那部分，之前一直搞不清楚该选哪个。',
    tag: '暗网入门',
  },
  {
    name: '深网探索者',
    time: '5小时前',
    content: '看了你们的暗网网址导航，终于找到几个靠谱的.onion搜索引擎了。之前在网上看到的各种暗网网址大全，大部分链接都打不开，这里的更新效率确实高。',
    tag: '网址导航',
  },
  {
    name: '安全第一',
    time: '1天前',
    content: '建议大家认真阅读暗网安全访问那篇文章，里面提到的防钓鱼技巧非常实用。我就是差点中了钓鱼链接的招，还好提前看了51暗网的警示文章，省了一大笔损失。',
    tag: '安全访问',
  },
  {
    name: '吃瓜路人',
    time: '2天前',
    content: '全网最全的暗网吃瓜爆料合集就在这里了！每天刷一刷最新动态，比逛论坛效率高多了。匿名投稿通道也很好用，已经推荐给身边对暗网好奇的朋友了。',
    tag: '吃瓜爆料',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100 text-center mb-3">
          读者热评
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10 max-w-lg mx-auto">
          暗网爱好者真实反馈，看看大家怎么说
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-4xl mx-auto">
          {comments.map((c, idx) => (
            <div
              key={idx}
              className="bg-background-50 border border-background-200/60 rounded-lg p-5"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-secondary-500/10 border border-secondary-500/20 flex items-center justify-center">
                  <span className="text-xs font-bold text-secondary-400">
                    {c.name.slice(0, 2)}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-200">{c.name}</p>
                  <p className="text-foreground-600 text-[11px]">{c.time}</p>
                </div>
                <span className="ml-auto px-2 py-0.5 bg-secondary-500/10 text-secondary-400 text-[10px] rounded font-medium">
                  {c.tag}
                </span>
              </div>
              <p className="text-foreground-500 text-xs leading-relaxed">{c.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}